/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowWineAndPaintNightTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowWineAndPaintNight,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Sip and Paint Together!",
    "Wine and Paint Night Awaits!",
    "Art and Wine for Everyone!",
  ],
  title: "Wine and Paint Night",
  description: "Organize a fun wine and paint night.",
  longDescription:
    "Gather your friends for an exciting wine and paint night! Choose a date, decide on paintings, and plan refreshments!",
  emoji: "🍷",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Wine and Paint Night",
          emoji: "🍷",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the wine and paint night?",
          emoji: "📅",
          completeAction: {
            question: "Decide on paintings to create?",
            description: "What paintings should we focus on during the night?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What paintings should we consider?",
                emoji: "🎨",
                completeAction: {
                  question: "Decide on refreshments?",
                  description:
                    "What refreshments should we plan for the night?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What refreshments should we bring?",
                      emoji: "🍇",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Create Art and Sip Wine!",
    outroDescription: "Your wine and paint night plans are set! Enjoy the fun!",
  },
};
